import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceResponse } from '@sdbn/appclient';
import { TransportOptionConfiguration } from './transport-options.model';

@Injectable({
    providedIn: 'root'
})

export class TransportOptionsAdministrationService {

    constructor(private http: HttpService) { }

    public loadOptionConfiguration(): Observable<TransportOptionConfiguration> {
        return this.http.postWithContext<TransportOptionConfiguration>(environment.transportOptionsEndpoint, {});
    }

    public saveTransportOptions(configuration: TransportOptionConfiguration): Observable<ServiceResponse> {
        return this.http.postWithContext<ServiceResponse>(environment.transportOptionsEndpoint + '/save', configuration);
    }
}
